import React, { useEffect, useState } from 'react';
import YoungApprenticeService from '../../services/YoungApprenticeService';

export default function YoungApprenticeModuleSettingsPanel({ compact = false }) {
  const [status, setStatus] = useState({ enabled: false, canToggle: false });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [feedback, setFeedback] = useState('');

  useEffect(() => {
    let mounted = true;
    YoungApprenticeService.moduleStatus()
      .then((data) => { if (mounted) setStatus({ enabled: Boolean(data?.enabled), canToggle: Boolean(data?.canToggle) }); })
      .catch(() => undefined)
      .finally(() => { if (mounted) setLoading(false); });
    return () => { mounted = false; };
  }, []);

  if (loading) return <div className="young-apprentice-settings">Carregando...</div>;
  if (!status.canToggle) return null;

  const toggle = async () => {
    const next = !status.enabled;
    setSaving(true); setFeedback('');
    try {
      const saved = await YoungApprenticeService.setModuleEnabled(next);
      const enabled = Boolean(saved?.enabled);
      setStatus((current) => ({ ...current, enabled }));
      setFeedback(enabled ? 'Módulo ativado.' : 'Módulo desativado.');
      window.dispatchEvent(new CustomEvent('bpm:young-apprentice-module-changed', { detail: { enabled } }));
    } catch (error) { setFeedback(error?.response?.data?.error || error?.message || 'Não foi possível alterar o módulo.'); }
    finally { setSaving(false); }
  };

  return <div className={`young-apprentice-settings${compact ? ' young-apprentice-settings--compact' : ''}`}>
    <div className="young-apprentice-settings__header"><strong>Jovem Aprendiz</strong><span className={`young-apprentice-settings__status ${status.enabled ? 'is-enabled' : ''}`}>{status.enabled ? 'Ativo' : 'Desativado'}</span></div>
    <button type="button" className="young-apprentice-settings__button" onClick={toggle} disabled={saving}>{saving ? 'Salvando...' : status.enabled ? 'Desativar módulo' : 'Ativar módulo'}</button>
    {feedback && <span className="young-apprentice-settings__feedback" aria-live="polite">{feedback}</span>}
  </div>;
}
